import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import ChatHeader from "./ChatHeader";
import ChatMessages from "./ChatMessages";
import ChatInput from "./ChatInput";
import Lottie from "lottie-react";
import cjhatAnimation from "../../../assets/lottie/chat.json";
import Button from "../../form/Button";
import SendMessagePopup from "./SendMessagePopup";

const MessageUi = ({
  sendMessageHandler = () => {},
  onMessageScroll = async () => {},
  getChatInfo = () => {},
  onDeleteMessage = () => {},
  chatList = [],
  chatData = [],
  chatInfo,
  meassageLoading = true,
  meassageFetching = true,
  activeChat,
  uploadProgress,
}) => {
  const [showChat, setShowChat] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const handleGetChatInfo = (chat) => {
    getChatInfo(chat);
    if (isMobile) setShowChat(true);
  };

  return (
    <div className="md:flex block md:flex-row h-full bg-slate-50 relative">
      {(!isMobile || !showChat) && (
        <div className="w-full md:w-auto">
          <Sidebar
            data={chatList}
            getChatInfo={handleGetChatInfo}
            activeChat={activeChat}
          />
        </div>
      )}

      {(!isMobile || showChat) && (
        <div className="p-4 w-full">
          <div className="flex flex-col w-full rounded-2xl bg-slate-100 overflow-hidden h-[calc(100vh-30px)] relative">
            {chatInfo?._id ? (
              <>
                {isMobile && (
                  <Button
                    buttonIcon={"fa-light fa-arrow-left"}
                    buttonIconPosition={"left"}
                    buttonLabelClasses={
                      "p-2 text-sm bg-chestnut-rose text-white rounded m-2 w-fit"
                    }
                    buttonFunction={() => setShowChat(false)}
                  />
                )}
                <ChatHeader info={chatInfo} />
                <ChatMessages
                  messages={chatData}
                  onScroll={onMessageScroll}
                  meassageLoading={meassageLoading}
                  meassageFetching={meassageFetching}
                  chatId={chatInfo?.chatId}
                  onDeleteMessage={onDeleteMessage}
                />
                <ChatInput
                  sendMessageHandler={sendMessageHandler}
                  uploadProgress={uploadProgress}
                />
              </>
            ) : (
              <div className="flex flex-col items-center justify-center w-full h-full">
                <div className="w-64 h-64 overflow-hidden">
                  <Lottie animationData={cjhatAnimation} loop={true} />
                </div>
                <div className="text-center font-semibold text-2xl p-4">
                  Stay updated with messages from the V'Peters Family
                  Scholarship
                  <br />
                  team—ask questions and keep the conversation going.
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {/* <SendMessagePopup /> */}
    </div>
  );
};

export default MessageUi;
